<template>
  <h-inspection-page
    :title="h_i18n('20982bbcdd7c5b929f427f654ea93f59')"
    @inspection-update="inspectionUpdate"
  >
    <!-- title-width="5" -->
    <form-header :title="h_i18n('20982bbcdd7c5b929f427f654ea93f59')">
      <!-- <template #title>
            <h-p align="left" title="表号">{{ data.DetailsInfo.patternPlanId }}</h-p>
            <h-p align="left" title="生效日期">{{ time(data.DetailsInfo.isrtDate,6) }}</h-p>
          </template> -->
      <template #body>
        <tr>
          <report-td :title="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" colspan="3:9">
            <span>{{ data.DetailsInfo.supplyCode }}</span>
          </report-td>
          <report-td :title="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" colspan="3:9">
            <span>{{ data.DetailsInfo.supplyName }}</span>
          </report-td>
        </tr>
        <tr>
          <report-td :title="h_i18n('ad539fd028219141d81a234286f290a8')" colspan="3:9">
            <span>{{ data.DetailsInfo.guarantyNo }}</span>
          </report-td>
          <report-td :title="h_i18n('6265d095fda40520557a7c9d3a92d2c0')" colspan="3:9">
            <!-- <span>{{ time(data.DetailsInfo.signDate, 3) }}</span> -->
            <el-tooltip
                effect="red"
                placement="top-start"
                :disabled="false"
                :visible="rulesForm.signDateTip"
                :content="h_i18n('25146ac66928d5d3ff3bb263dc16021d')"
              >
                <div></div>
              </el-tooltip>
              <!-- :disabled-date="
                  (time) =>
                    time.getTime() < new Date().getTime() - 24 * 60 * 60 * 1000
                " -->
              <el-date-picker

                style="width:100%"
                type="date"
                v-model="data.addForm.signDate"
                :placeholder="h_i18n('4ff1e74e43a3586339251494117185ad')"
              ></el-date-picker>
          </report-td>
        </tr>
        <tr>
          <report-td :title="h_i18n('383a6d166f8f60e16e726ccc9c483631')" colspan="3:9">
            <!-- <span>{{ data.DetailsInfo.materielCategoryName }}</span> -->
            <el-tooltip
                effect="red"
                placement="top-start"
                :disabled="false"
                :visible="rulesForm.materielCategoryIdTip"
                :content="h_i18n('4daf6c89e01a3a7d07debbb2c44e9e56')"
              >
                <div></div>
              </el-tooltip>
            <el-select
              v-model="data.addForm.materielCategoryId"
              :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')"
              clearable
              filterable
            >
              <el-option
                v-for="item in data.materielCategoryList"
                :key="item.valueId"
                :label="item.valueName"
                :value="item.valueId"
              >
              </el-option>
            </el-select>
          </report-td>
          <report-td :title="h_i18n('d503a29b7898f3f97ac773c542a70eb1')" colspan="3:9">
            <div>
              <el-tooltip effect="red" placement="top-start" :disabled="false" :visible="rulesForm.fileUploadType" :content="h_i18n('a6f9f534bb85d3df5e1c3f8ff1561669')">
                <div></div>
              </el-tooltip>
              <h-button @click="data.fileChoose = true" type="primary">{{ h_i18n('0063c51e228e58fddadbff82a79cf3c0') }}</h-button>
            </div>
          </report-td>
        </tr>
        <tr>
          <!-- <report-td title="审核人" colspan="3:9">
            <span>{{ data.DetailsInfo.reviewName }}</span>
          </report-td> -->
          <report-td :title="h_i18n('8c4ab5982fcea30b260715ac494e7922')" colspan="3:9">
            <span v-if="data.DetailsInfo.reviewResult == 'W'">{{ h_i18n('5cb424765cb101866f47ca115605ce3b') }}</span>
            <span v-else-if="data.DetailsInfo.reviewResult == 'P'"
              >{{ h_i18n('871a30c0993c4e2a71557fe7f38807c0') }}</span>
            <span v-else-if="data.DetailsInfo.reviewResult == 'F'"
              >{{ h_i18n('b748ef6566aff87d0f677e431a2038b0') }}</span>
          </report-td>
          <report-td :title="h_i18n('e6f0708789d7efc02f1a163224ae7fb0')" colspan="3:9">
            <span>{{ time(data.DetailsInfo.reviewDate, 6) }}</span>
          </report-td>
        </tr>
        <tr>
          <!-- <report-td title="审核结论" colspan="3:9">
            <span v-if="data.DetailsInfo.reviewResult == 'W'">待审核</span>
            <span v-else-if="data.DetailsInfo.reviewResult == 'P'"
              >审核通过</span
            >
            <span v-else-if="data.DetailsInfo.reviewResult == 'F'"
              >审核打回</span
            >
          </report-td> -->
          <report-td :title="h_i18n('ab1bcd732b932ead763bf080d90e93ab')" colspan="3:21">
            <span>{{ data.DetailsInfo.reviewReason }}</span>
          </report-td>
        </tr>
        <tr>
          <report-td :title="h_i18n('2432b57515b3627faddccb1dd1df206e')" colspan="3:21">
            <!-- <span>{{ data.DetailsInfo.remark }}</span> -->
            <el-tooltip
              effect="red"
              placement="top-start"
              :disabled="false"
              :visible="rulesForm.remarkTip"
              :content="h_i18n('c7df2bc496873040622d0fd9f5c82e21')"
            >
              <div></div>
            </el-tooltip>
            <el-input
              v-model="data.addForm.remark"
              type="textarea"
              :rows="4"
              maxlength="200"
              show-word-limit
            ></el-input>
          </report-td>
        </tr>
        <tr>
          <report-td :title="h_i18n('1bbbb204023e59eba03319c7c5848fd1')" colspan="3:21">
            <div style="color: red;font-size: 12px;">
              <p>{{ h_i18n('d848a36eedf516d714dc06ab46fd558c') }}</p>
              <p>{{ h_i18n('27d9a20033921818e1ff70818004d461') }}</p>
              <p>{{ h_i18n('676f2b994cdb44efda8f546e5301fca1') }}</p>
              <p style="text-indent: 10px;">{{ h_i18n('c5b91036b4e2d299b8f372bc6dc8cdad') }}</p>
              <p style="text-indent: 10px;">{{ h_i18n('36C1F9B35EC2ACE67A4C6156C3F22C25') }}</p>
              <p style="text-indent: 58px;">{{ h_i18n('b260dbf964e8868a75a51f5aaf0b8ffe') }}</p>
              <p style="text-indent: 58px;">{{ h_i18n('533e964b2babbbce2dc1e4e0db509b7a') }}</p>
            </div>
          </report-td>
        </tr>
      </template>
    </form-header>
    <div style="padding-top:10px;padding-bottom:10px;">
      <h-button-group align="center">
        <h-button type="primary" @click="submitAddForm" v-loading="data.submitLoading">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
        <h-button type="default" @click="$router.back()">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
      </h-button-group>
    </div>
    
    <h-dialog class="over_dialog_style" :show="data.fileChoose" :title="h_i18n('481e034e6026969aae4ce7ce7c8a7b6f')" footer @close="data.fileChoose = false"
        width="750px">
        <el-row>
          <div style="color:red;font-size:14px;height:28px;line-height:28px;padding-left: 28px;">{{ h_i18n('0a94aa92aebd0d07cd2fffcb3c3b545f') }}</div>
        </el-row>
        <el-row>
          <div style="font-size:14px;height:28px;line-height:28px;padding: 20px 0 20px 28px">
            <span style="font-weight:600">{{ h_i18n('2bc21499c9adb3d1470d91b7f7bc7351') }}</span> 
            <span style="text-align: left; color:#2681ff;cursor:pointer;" @click="downF('环保承诺书')">环保承诺书（直采专用）</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span style="text-align: left; color:#2681ff;cursor:pointer;" @click="downF('Environmental')">Environmental Protection Commitmen</span>
          </div>
        </el-row>
        <el-row>
          <hc-file-upload :info="h_i18n('0a94aa92aebd0d07cd2fffcb3c3b545f')" v-model="data.addForm.file"
            delete download @change="fileUpChange" @delete="deleteFile" @error="error"
            @download="downLoadFile"></hc-file-upload>
        </el-row>
    </h-dialog>

  </h-inspection-page>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import { reactive, getCurrentInstance, onMounted, onActivated } from "vue";
import axios from "axios";
import { useRoute } from "vue-router";
const { proxy } = getCurrentInstance();
const route = useRoute();
const downF = (v) => { 
  let url = ''
  let name = ''
  if(v === '环保承诺书'){
    url = '/basicInfo/环保承诺书（直采专用）.docx';
    name = '环保承诺书（直采专用）.docx'
  }else if(v === 'Environmental'){
    url = '/basicInfo/Environmental Protection Commitmen.docx';
    name = 'Environmental Protection Commitmen.docx'
  }
  proxy.startLoading()
  proxy.httpFile({
    method: 'get',
    url:'/base/fileDownload/downloadFile?filePath=' + url,
    headers: { 'content-type': 'application/json' }
  },name)
};
const data = reactive({
  fileChoose: false,
  name: "", // 用户账号
  nickName: "", // 用户昵称
  loading: false, // 表单提交加载
  submitLoading: false,
  envId: "",
  dataTableList: [],
  DetailsInfo: {}, // 详情信息
  addForm: {
    file: {},
  },
  materielCategoryList: [], // 物料大类列表
});
// 验证表单
const rulesForm = reactive({
  signDateTip: false,// 合同签订日期
  materielCategoryIdTip: false,// 类别
  remarkTip: false, // 备注
  fileUploadType: false
});
const fileUpChange = (options, promise) => {
  let formData = new FormData();
  formData.append("files", options.file);
  proxy
    .$http({
      method: "post",
      // url: '/base/fileUpload/uploadToOssSaveUrl',
      url: "/base/fileUpload/uploadToOss",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      cache: false,
      processData: false,
      contentType: false,
    })
    .then((res) => {
      data.addForm.fileId = res.data.data;
      data.addForm.fileName = options.file.name;
      data.fileChoose = false
    })
    .catch((err) => {
      proxy.error(h_i18n('8e2f993840e3108c7f6d8f23d6a8a08d'));
    });
};
const deleteFile = () => {
  data.addForm.fileId = "";
  data.addForm.fileName = "";
  data.addForm.file = undefined;
};
const error = (str) => {
  proxy.warning({ title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: str, confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721') });
};
const downLoadFile = () => {
  proxy.startLoading(h_i18n('29f986479f7cf1f93d31172f343d4521'));
  let suffix = data.addForm.fileId.includes("mkhl/");
  if (suffix) {
    let url = "/base/fileDownload/downloadFile?filePath=" + data.addForm.fileId;
    // let url = "/tosqmfordown/readFile/" + data.addForm.fileId;
    proxy.httpFile(
      {
        method: "get",
        url: url,
        headers: { "content-type": "application/json" },
      },
      data.addForm.fileName
    );
  } else {
    let url = `/base/fileDownload/downLoadFileFtp?type=6&fileUUID=${data.addForm.fileId}`;
    // let url = `/tosqmfordown/downLoadFileNew?type=6&fileUUID=${data.addForm.fileId}`;
    proxy.httpFile(
      {
        method: "get",
        url: url,
        headers: { "content-type": "application/json" },
      },
      data.addForm.fileName
    );
  }
};
const getDetails = () => {
  proxy
    .$http({
      // /smallBatchVerificationNew/getDetailById
      url: "/base/environmentWithHMQM/getDetailById",
      method: "get",
      params: {
        envId: data.envId,
      },
    })
    .then((res) => {
      console.log(res, "查询详情");
      if (res.data.code == 200) {
        data.DetailsInfo = res.data.data;
        data.addForm.fileId = data.DetailsInfo.fileId;
        data.addForm.fileName = data.DetailsInfo.fileName;
        data.addForm.remark = data.DetailsInfo.remark;
        data.addForm.materielCategoryId = data.DetailsInfo.materielCategoryId;
        data.addForm.materielCategoryName = data.DetailsInfo.materielCategoryName;
        data.addForm.signDate = data.DetailsInfo.signDate;
        data.addForm.file.name = data.DetailsInfo.fileName;
      } else {
        data.DetailsInfo = {};
        proxy.warning({
          message: res.data.msg ? res.data.msg : h_i18n('21efd88b67a39834582ad99aabb9dc60'),
          title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770'),
        });
      }
    });
};

const submitAddForm = () => {
  if(data.addForm.signDate == '' || data.addForm.signDate == null || data.addForm.signDate == undefined) {
    rulesForm.signDateTip = true;
    setTimeout(() => {
      rulesForm.signDateTip = false;
    }, 2000);
    return false;
  }
  if(data.addForm.materielCategoryId == '' || data.addForm.materielCategoryId == null || data.addForm.materielCategoryId == undefined) {
    rulesForm.materielCategoryIdTip = true;
    setTimeout(() => {
      rulesForm.materielCategoryIdTip = false;
    }, 2000);
    return false;
  }
  if(data.addForm.remark == '' || data.addForm.remark == null || data.addForm.remark == undefined) {
    rulesForm.remarkTip = true;
    setTimeout(() => {
      rulesForm.remarkTip = false;
    }, 2000);
    return false;
  }
  if(data.addForm.fileId === '' || data.addForm.fileId === null || data.addForm.fileId === undefined) {
    rulesForm.fileUploadType = true;
    setTimeout(() => {
      rulesForm.fileUploadType = false;
    }, 2000);
    return false;
  }
  console.log(data.materielCategoryList,"类别列表")
  data.materielCategoryList.forEach((el)=>{
    if(el.valueId == data.addForm.materielCategoryId) {
      data.addForm.materielCategoryName = el.valueName;
    }
  })
  data.addForm.supplyCode = data.supplyCode;
  data.addForm.supplyName = data.supplyName;
  data.addForm.inputName = data.trueName;
  data.addForm.envId = data.envId;
  data.addForm.signDate = proxy.time(data.addForm.signDate);
  console.log(data.addForm,"提交的数据")
  data.submitLoading = true;
  proxy
    .$http({
      url: "/base/environmentWithHMQM/environmentSubmit",
      method: "POST",
      data: {
        ...data.addForm,
      },
    })
    .then((res) => {
      console.log(res, "/base/environmentWithHMQM/environmentSubmit");
      if (res.data.code == 200) {
        data.submitLoading = false;
        proxy.success({
          title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
          message: res.data.data,
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback: () => {
            proxy.$router.back();
          },
        });
      } else {
        data.submitLoading = false;
        proxy.warning({
          message: res.data.msg ? res.data.msg : h_i18n('6452a05591d7402a8bcd9fadc950c449'),
          title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770'),
        });
      }
    });
}
// 获取物料大类
const getMaterielCategories = () => {
  proxy
    .$http({
      method: "get",
      url: "/base/basicData/getMaterielCategories",
      headers: { "content-type": "application/json" },
      params: {
        name: data.name,
        nickName: data.nickName,
        userCode: data.name,
      },
    })
    .then((res) => {
      console.log(res, "getMaterielCategories");
      data.materielCategoryList = res.data.data.map((el) => {
        return {
          valueId: el.materielCategoryId,
          valueName: el.materielCategoryName,
        };
      });
    });
};
const inspectionUpdate = () => {
  proxy.postThisPageHeight();
};
onMounted(() => {
  if (route.query) {
    data.supplyCode = route.query.supplyCode;
    data.supplyName = route.query.supplyName;
    data.trueName = route.query.trueName;
    data.username = route.query.username;
    data.roleCode = route.query.roleCode;
    data.envId = route.query.envId;
    getMaterielCategories();
    getDetails();
  }
});
</script>

<style scoped lang="scss">
.h-hwork-form-header {
  padding: 0;
}

:deep(.haier-table-header--right) {
  position: unset !important;
}

.haier-td {
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  text-align: left;
  padding: 4px 10px;
  font-size: 14px;
  height: 35px;
  color: #666;
}

.haier-cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.haier-text-right {
  text-align: right;
}

.haier-cell:hover {
  white-space: normal;
  word-break: break-all;
}
</style>

<style lang="scss">
.el-popper.is-red {
  /* Set padding to ensure the height is 32px */
  padding: 6px 12px;
  background: linear-gradient(90deg, rgb(255, 0, 0), rgb(255, 0, 0));
  color: #fff;
}
//.el-popper__arrow {
//  left: -50px !important;
  // margin-left: 10px !important;
//}
.el-popper.is-red .el-popper__arrow::before {
  background: linear-gradient(45deg, #ff0000, #ff0000);
  // right: 0;
}
.planHidden {
  display: none;
}
</style>